import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import ValueRanking from '../../../../components/modules/marketing/value-ranking';
import ValueRankingMiddleware from '../../../../middleware/modules/marketing/value-ranking';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,valueRanking }) => ({
  isProcessing: valueRanking.isProcessing,
  isError: valueRanking.isError,
  errorMessage: valueRanking.errorMessage,
  data:valueRanking.data,
  showModal:valueRanking.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>ValueRankingMiddleware.create(),
    reset: () =>ValueRankingMiddleware.resetList(),
    search: data =>ValueRankingMiddleware.list(data),
    view: data =>ValueRankingMiddleware.getOne(data),
    delete: (id,search) =>ValueRankingMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class ValueRankingContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
   this.props.search(search);
  
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    
    this.props.update(id)
  }
  createItem(){
    this.props.create()
  }
  render() {
    const {isProcessing, search ,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Value Ranking List")}
          </title>
        </Helmet>
      <ValueRanking
        {...this.props}
        search={search}
        isProcessing={isProcessing}
        showModal={showModal}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ValueRankingContainer);
